// https://stackoverflow.com/questions/51750084/slick-slider-centermode
const carousel = {

    elements: {},

    cacheDom() {
        this.elements.carousel = document.querySelectorAll('.js-carousel');
    },

    resizeCarousel( carousel ) {
        const captions = carousel.querySelectorAll('.carousel__caption');
        let tallestCaption = 0;
        let slideImageHeight = 0;

        Array.prototype.forEach.call( captions, caption => {
            caption.classList.add('carousel__caption--measuring');
            const rect = caption.getBoundingClientRect();
            const captionHeight = caption.offsetHeight;
            const slideImage = caption.parentNode.querySelector('img');
            caption.classList.remove('carousel__caption--measuring');
            
            tallestCaption = (captionHeight > tallestCaption ) 
                ? captionHeight 
                : tallestCaption;

            slideImageHeight = (slideImage.height > slideImageHeight) 
                ? slideImage.height 
                : slideImageHeight;
        });

        // slideImageHeight = slideImageHeight * 1.333;

        let height = (tallestCaption + slideImageHeight);
        height += 40; // directional nav
        carousel.style.height = height + 'px';
    },

    bind() {

        if( this.elements.carousel )
        {
            this.elements.carousel.forEach( element => {
                
                const $carousel = jQuery(element);

                this.resizeCarousel( element );

                window.addEventListener('resize', e => {
                    this.resizeCarousel( element );
                });

                document.addEventListener('DOMContentLoaded', e => {
                    this.resizeCarousel( element );
                })

                $carousel.slick({
                    arrows: false,
                    dots: false,
                    centerMode: true,
                    slidesToShow: 3,
                    speed: 200,
                    centerPadding: 0,
                    //variableWidth: true,
                    responsive: [{
                        breakpoint: 860,
                        settings: {
                            centerMode: false,
                            slidesToShow: 1
                        }
                    }]
                });

                element.addEventListener('click', e => {
                    
                    if( e.target.classList.contains('js-carousel-next') ) {
                        $carousel.slick("slickNext");
                    } else if ( e.target.classList.contains('js-carousel-prev') ) {
                        $carousel.slick("slickPrev");
                    }
                });

            });
        }
    },

    init() {
        
        this.cacheDom();
        this.bind();
    }
}

export default carousel;